import axios from 'axios';

export function getBuildingTypes() {
  return axios.get(`/public/building-types`);
}

export function getStatistics() {
  return axios.get(`/public/statistics`);
}

export function postSearch(type, size) {
  return axios.post(`/public/search`, {
    type: type,
    size: size
  });
}

export function getPath(path) {
  return axios.get(path);
}